import { render, staticRenderFns } from "./OJsonTextArea.vue?vue&type=template&id=3d4ce032&scoped=true"
import script from "./OJsonTextArea.vue?vue&type=script&lang=js"
export * from "./OJsonTextArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4ce032",
  null
  
)

export default component.exports